// ───────────────────────────────────────────────
// Shell-less layout for the auth pages — a centered card on a plain
// background, with no sidebar or topbar.
// ───────────────────────────────────────────────
import { Brandmark, Wordmark } from "./Brand";

export function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-brand">
          <div className="brand-mark">
            <Brandmark />
          </div>
          <Wordmark />
        </div>

        {title && <h1 className="auth-title">{title}</h1>}
        {subtitle && <p className="auth-sub">{subtitle}</p>}

        {children}

        {footer && <div className="auth-foot">{footer}</div>}
      </div>
    </div>
  );
}
